export default __webpack_public_path__ + "images/IU.02edd7e.png";